import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["siteName", "productConfig", "authConfig", "location", "callback", "analyticsInfo", "environment", "onHostRedirect", "onClose", "isModal"];
import React from 'react';
import { ThemeProvider } from '@chegg-ui/theme';
import { themes, createTheme } from '@chegg-ui/theme';
import { BlockedRegionContent } from '../BlockedRegionContent';
import { useRegionValidation } from '../../hooks/useRegionValidation';
import WtOneClick from '../WtOneClick';
var WritingCheckout = function WritingCheckout(_ref) {
  var _location$countryCode, _location$region;
  var siteName = _ref.siteName,
    productConfig = _ref.productConfig,
    authConfig = _ref.authConfig,
    location = _ref.location,
    callback = _ref.callback,
    analyticsInfo = _ref.analyticsInfo,
    environment = _ref.environment,
    onHostRedirect = _ref.onHostRedirect,
    onClose = _ref.onClose,
    isModal = _ref.isModal,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useRegionValidation = useRegionValidation({
      countryCode: (_location$countryCode = location.countryCode) !== null && _location$countryCode !== void 0 ? _location$countryCode : '',
      region: (_location$region = location.region) !== null && _location$region !== void 0 ? _location$region : '',
      environment: environment,
      siteName: siteName
    }),
    countryCode = _useRegionValidation.countryCode,
    isRegionBlocked = _useRegionValidation.isRegionBlocked,
    regionLoadInProgress = _useRegionValidation.regionLoadInProgress;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !regionLoadInProgress && /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createTheme({}, themes.horizon)
  }, isRegionBlocked ? /*#__PURE__*/React.createElement(BlockedRegionContent, {
    onClickNoThanks: restProps.onClickNoThanks,
    environment: environment,
    siteName: siteName
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WtOneClick, {
    productConfig: productConfig,
    countryCode: countryCode,
    callback: callback,
    analyticsInfo: analyticsInfo,
    authConfig: authConfig,
    environment: environment,
    onHostRedirect: onHostRedirect,
    siteName: siteName,
    onClose: onClose,
    isModal: isModal
  }))));
};
export default WritingCheckout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/Checkout/index.js
// module id = 2596
// module chunks = 11